
import { UserOutlined } from '@ant-design/icons';
import { Button, Form, Input, message, Spin } from 'antd';
import { setOtpVerifiedEmailAction } from 'common/commonRedux/auth/actions';
import { useAxiosRequest, useIsDark } from 'common/hooks';
import { useDispatch } from 'react-redux';
import { Link } from 'react-router-dom';
import './SpinColor.css';
export default function SendOTPToVerifyEmail() {
  const isDark = useIsDark();
  const dispatch: any = useDispatch();
  const postSendOtp = useAxiosRequest(null);
  const [form] = Form.useForm();



  const onFinish = (values: any) => {
    const email = values.email;
    // console.log(email);
    
    postSendOtp.apiAction({
      urlObjKey: 'SendOtpForResetPassword',
      params: { email },
      method: 'POST',
      // isToast: true,
      // toastType: 'small',
      // successMessage: 'OTP send successful!',
      // errorMessage: 'Something wrong to send the OTP',
      cb: (res) => {
        // console.log(res);
        if(res.statuscode === 200) {
          form.resetFields();
          dispatch(setOtpVerifiedEmailAction(email))
          message.success(res?.message)
        }else {
          message.error(res?.message);
          // throw new Error(res.message);
        }
        
      },
      onError: (error) => {
        console.error('Otp send fail:', error);
        message.error(
          {
            content: error?.response?.data?.message ||
            error?.response?.data?.Message ||
            'An error occurred. Please try again',
            duration: 5,
          }
        );
      },
    });
  };

  const onFinishFailed = () => { };

  return (
  
      <Form
        name="basic"
        layout="vertical"
        requiredMark={false}
        initialValues={{
          remember: true,
        }}
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
        autoComplete="off"
        className='w-full'
      >
        <Form.Item
          name="email"
          className="mb-5 "
          label={
            <span className={`text-md font-bold ${isDark ? 'text-white' : 'text-[#333]'}`}>
              Email <span style={{ color: 'red' }}>*</span>
            </span>
          }
          rules={[{ required: true, message: 'Please input your User Email' }]}
        >
          <Input
          size='large'
            placeholder="Enter you organization email"
            prefix={<UserOutlined className="site-form-item-icon" />}
          />
        </Form.Item>

        <Form.Item className="mb-5">
          <Button
          disabled= {postSendOtp?.isLoading}
          //   type="primary"
          size='large'
            htmlType="submit"
            className="w-full  !text-white  font-medium"
            style={{
              background:
                '#1677ff',
            }}
          >
           <span className='mr-1'>Send OTP </span>  {postSendOtp?.isLoading && <Spin  />}
          </Button>
          
          {/* Divider */}
          {/* <div className="text-center text-[#333333] text-md font-bold my-4 ">
              or
            </div> */}
          <p className={`pt-4 text-center ${isDark ? 'text-[#CBD5E1]' : ''}`}>
            Want to return to login?{' '}
            <Link
              to={`/login`}
              className="text-sm text-primaryColor font-semibold"
            >
              Login
            </Link>
          </p>
        </Form.Item>
      </Form>
    
  );
}
